
  import { createApiClient } from 'Network/ApiClient';
  
  export const IcdAxiosInstance = createApiClient('icd/');







